// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-1l44VvMs","hongbaoBox":"hongbaoBox-1eVtg92H","close":"close-2_dFBGD7","image":"image-2EjP3sR5","tada":"tada-3pMwymAf"};